import { Component } from 'preact';
import { sortAuthModes } from '../../controllers/bank-mandate';
import { getKey } from '../../utils/common';
import CONSTANT from '../../utils/constants';
import { locale } from '../../utils/i18n';

export default class BankAuthenticate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectAuthMode: props.populateMode ? props.populateMode : '',
      authError: '',
      authModes: sortAuthModes(props.authenticateModes || [])
    };
  }

  componentWillReceiveProps(props) {
    if (props.authModeError !== this.state.authError) {
      this.setState({ authError: props.authModeError });
    }
    this.setState({ authModes: sortAuthModes(props.authenticateModes) });
  }

  componentDidMount() {
    const banksLenght = getKey(this.state, 'authModes.length', 0);
    // Auto select first mode
    if (banksLenght > 0) {
      if (this.props.selectMode && typeof this.props.selectMode === 'function') {
        this.props.selectMode(this.state.authModes[0]);
      }
    }
  }

  render({ selectMode, populateMode }, { authModes, authError }) {
    return (
      <div className={`ptm-auth-wrap ptm-w100-ib  ptm-pos-r`}>
        <div className={`ptm-auth-text`}>{locale('bm.authenticate.using')}</div>
        {authModes &&
          authModes.map(mode => {
            return (
              <div className={`ptm-bm-radio-wrap`}>
                <div>
                  <label class="ptm-lbl">
                    <input
                      type="radio"
                      class="ptm-margin0"
                      name="authenticatemode"
                      value={mode}
                      checked={populateMode === mode}
                      onClick={() => selectMode(mode)}
                    />
                    <span class="ptm-checkmark" area-hidden="true" />
                    <div className={` ptm-pay-method-cont  ptm-pos-r`}>
                      {CONSTANT.MANDATE_AUTH_MODES[mode]}
                    </div>
                  </label>
                </div>
              </div>
            );
          })}
        <p className={`ptm-small-txt ptm-msg-red`}>{authError}</p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/bank-mandate/bank-authenticate.js